import React, { HTMLAttributes } from "react";
import classnames from "classnames";

import "./TabControl.scss";

interface RouterLink {
  to?: string;
  classNameCallback?: ({ isActive: boolean }) => string;
}

interface TabConfig extends HTMLAttributes<HTMLButtonElement>, RouterLink {
  as?: any;
  disabled?: boolean;
  type?: string;
  ariaLabel?: string;
}

export interface TabItem {
  content: string;
  id: string;
  config?: TabConfig;
}

interface TabControlProps {
  item: TabItem;
  selected?: boolean;
  onClick?: (id: string) => void;
}

export const TabControl = ({ item, selected, onClick }: TabControlProps) => {
  const { content, id, config = {} as TabConfig } = item;
  const { as, ariaLabel, classNameCallback, ...props } = config;

  const Component = as || "button";

  const additionalConfig = {} as TabConfig;

  if (onClick) {
    additionalConfig.onClick = () => onClick(id);
  }

  if (Component === "button") {
    additionalConfig.type = "button";
  }

  if (selected) {
    additionalConfig.tabIndex = -1;
  }

  return (
    <Component
      {...props}
      {...additionalConfig}
      aria-label={ariaLabel}
      className={
        classNameCallback ||
        classnames("tab-control", props.className, {
          "tab-control--selected": selected,
          "tab-control--disabled": props.disabled,
        })
      }
    >
      {content}
    </Component>
  );
};
